import Api from "../api";
let uri = "/api/ed/favoritos/";

export const addFavorite = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}`, data)
    .then((resp) => resp);
};
